import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\UpdateDiaryChiftInvoicingPaymentSyncController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/UpdateDiaryChiftInvoicingPaymentSyncController.php
* @route '/api/accounting-diary/{accounting_diary}/partners/chift-invoicing/payment-sync'
*/
const UpdateDiaryChiftInvoicingPaymentSyncController = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDiaryChiftInvoicingPaymentSyncController.url(args, options),
    method: 'put',
})

UpdateDiaryChiftInvoicingPaymentSyncController.definition = {
    methods: ["put"],
    url: '/api/accounting-diary/{accounting_diary}/partners/chift-invoicing/payment-sync',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\UpdateDiaryChiftInvoicingPaymentSyncController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/UpdateDiaryChiftInvoicingPaymentSyncController.php
* @route '/api/accounting-diary/{accounting_diary}/partners/chift-invoicing/payment-sync'
*/
UpdateDiaryChiftInvoicingPaymentSyncController.url = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { accounting_diary: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { accounting_diary: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            accounting_diary: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        accounting_diary: typeof args.accounting_diary === 'object'
        ? args.accounting_diary.id
        : args.accounting_diary,
    }

    return UpdateDiaryChiftInvoicingPaymentSyncController.definition.url
            .replace('{accounting_diary}', parsedArgs.accounting_diary.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\UpdateDiaryChiftInvoicingPaymentSyncController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/UpdateDiaryChiftInvoicingPaymentSyncController.php
* @route '/api/accounting-diary/{accounting_diary}/partners/chift-invoicing/payment-sync'
*/
UpdateDiaryChiftInvoicingPaymentSyncController.put = (args: { accounting_diary: string | number | { id: string | number } } | [accounting_diary: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDiaryChiftInvoicingPaymentSyncController.url(args, options),
    method: 'put',
})

export default UpdateDiaryChiftInvoicingPaymentSyncController